import styled from 'styled-components';

import { rem } from 'approot/shared/style';
import { PStyled } from 'approot/shared/styles/typography.style';
import { grey1 } from 'approot/shared/styles/colours.style';
import { spacing24 } from 'approot/shared/styles/spacing.style';

// use rgba(255, 255, 255, 0) instead of transparent to fix Safari black shadow
export const ReadMoreContent = styled.span<{ isPreview: boolean }>`
  position: relative;
  display: inline-block;

  ${({ isPreview }) =>
    isPreview
      ? `
        &::after {
          content: '';
          position: absolute;
          bottom: 0;
          left: 0;
          width: 100%;
          height: ${rem(spacing24)};
          background: linear-gradient(to bottom, rgba(255, 255, 255, 0), ${grey1}); 
        }
    `
      : ''}
`;

export const ReadMoreParagraph = styled(PStyled)<{
  marginBottom: number;
}>`
  margin-bottom: ${({ marginBottom }) => rem(marginBottom)};
`;

export const ReadMoreWrapper = styled(ReadMoreContent).attrs({
  as: 'div',
})<{ isPreview: boolean }>`
  height: ${({ isPreview }) => (isPreview ? rem(94) : 'auto')};
  overflow: hidden;
  width: 100%;
  & > div p:last-child {
    margin-bottom: 0;
  }
`;
